export default __webpack_public_path__ + "static/media/slider-smc360-3.0942346f.jpg";